export interface MissionUpdate {
  id: string;
  body: string;
  createdAt: string;
  /** Google email of admin who posted (team board) */
  authorEmail?: string;
  /** Google display name when available */
  authorDisplayName?: string;
}

export interface StatusDef {
  id: string;
  label: string;
  /** 0–7 — maps to pill gradient in CSS */
  variant: number;
}

export interface PriorityDef {
  id: string;
  label: string;
  variant: number;
}

export interface MissionsCatalog {
  people: string[];
  /** Avatar color index 0–7 per person row (parallel to `people`) */
  personTones?: number[];
  statuses: StatusDef[];
  priorities: PriorityDef[];
}

export interface MissionRow {
  id: string;
  mission: string;
  person: string;
  statusId: string;
  priorityId: string;
  endDate: string;
  details: string;
  updates: MissionUpdate[];
  /** Hidden from main board; shown under Archived */
  archived?: boolean;
}

/** Labels for pill style pickers in the catalog editor */
export const PILL_STYLE_LABELS = [
  'Slate',
  'Sky',
  'Violet',
  'Amber',
  'Coral',
  'Emerald',
  'Fuchsia',
  'Teal',
] as const;
